import debug from '../qa/debug';
import {
  submitEvent,
  submitEventMerge,
  submitMerge,
  submitMiniAction,
  submitMove,
  trackOnNextPageImpression
} from '@otto-ec/tracking-bct';

const emitMiniActionEvent = (featureIds) => {
  const payload = featureIds.map((featureId) => ({
    featureId
  }));
  submitMiniAction(payload);
  debug.log('miniaction submitted', payload);
};

const emitSustainabilityLabelClickEvent = (payload) => {
  submitEvent(payload);
  debug.log('sustainability label click tracking', payload);
};

const emitScrollEvent = (scrollPayload, additionalTrackingLabels) => {
  submitEvent(additionalTrackingLabels, scrollPayload);
  debug.log('scroll table tracking', scrollPayload);
};

const emitFreshViewEvent = (payload) => {
  submitMerge({}, payload);
  debug.log('table view page tracking', payload);
};

const emitClickEvent = (
  moveActionPayload,
  onNextPageImpressionPayload,
  additionalTrackingLabels
) => {
  trackOnNextPageImpression(onNextPageImpressionPayload);
  debug.log(
    'table click tile tracking - on next page impression',
    JSON.stringify(onNextPageImpressionPayload)
  );

  submitMove(additionalTrackingLabels, moveActionPayload);
  debug.log(
    'table click tile tracking - move action)',
    JSON.stringify(additionalTrackingLabels),
    JSON.stringify(moveActionPayload)
  );
};

const emitActionViewEvent = (payload, eventMergeId, actionName) => {
  const event = {
    name: actionName,
    features: payload
  };
  submitEventMerge(eventMergeId, {}, event);
  debug.log(`table view page tracking - ${actionName} action`, payload);
};

export {
  emitMiniActionEvent,
  emitSustainabilityLabelClickEvent,
  emitScrollEvent,
  emitFreshViewEvent,
  emitClickEvent,
  emitActionViewEvent
};
